export default __webpack_public_path__ + "static/Entenda0080-a881e9c839d0721944fd6db8aa8ff0d5.jpg";